// prettier-ignore
lingoda.app = angular.module('lingoda', [
    'ui.bootstrap',
    'lingoda.animation',
    'lingoda.timer',
    'lingoda.fields',
    'lingoda.fields.date',
    'lingoda.fields.file',
    'lingoda.fields.radio',
    'lingoda.fields.select',
    'lingoda.fields.slider',
    'lingoda.scroller',
    'lingoda.form',
    'lingoda.loader',
    'lingoda.payment'
].concat(lingoda.modules))
.run(['$rootScope', '$timeout', 'helper', function($rootScope, $timeout, helper) {
    /* Main Navigation */
    $rootScope.sidePanel = {
        toggle: function(model) {
            var oldState = this.active;
            if(this.active == model) {
                this.active = false;
                this[model] = false;
            } else {
                this.active = model;
                this[model] = true;
            }
            if(model != oldState) {
                this[oldState] = false;
            }
        },
        hide: function() {
            var current = this.active ? this.active : false;
            this.active = false;
            if(current) {
                this[current] = false;
            }
        },
        getClass: function() {
            return this.active ? ('side-panel-active-' + this.active) : '';
        }
    };

    $rootScope.shareFacebook = function(url) {
        FB.ui({
            method: 'share',
            href: url,
        }, function(response){});
    };

    $rootScope.global = {};

    //Hide sidebar
    $('#contentLayout, #main-navigation-mobile-menu').bind('click', function(e) {
        if(!$(e.target).hasClass('open-sidebar')) {
            $rootScope.sidePanel.hide();
        }
    });

    /* Fix fixed header */
    if(helper.isMobile()) {
        var $body = jQuery('body'),
            timeoutID;
        $(document)
        .on('focusin', 'input, textarea', function(e) {
            $timeout.cancel(timeoutID);
            $body.addClass('fix-fixed');
            $timeout(function() {
                $rootScope.sidePanel.hide();
            });
        })
        .on('focusout', 'input, textarea', function(e) {
            timeoutID = $timeout(function() {
                $body.removeClass('fix-fixed');
            });
        });
    }

}])
.config(['$compileProvider', function($compileProvider){
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|skype):/);
    // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
}])
.service('helper', function() {
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;

    this.isMobile = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };
    this.scrollTo = function(element, duration) {
        var elementTop = $(element).offset().top - 10;
        duration = angular.isDefined(duration) ? duration : 400;
        $('body,html').animate({scrollTop: elementTop - this.getHeaderHeight()}, duration);
    };
    this.getHeaderHeight = function() {
        var fixedHeader = $('.fixed-top')[0] ? $('.fixed-top')[0].offsetHeight : 0,
            navigation = $(window).width() > 991 ? $('#main-navigation-menu')[0].offsetHeight : $('#main-navigation-mobile-menu')[0].offsetHeight,
            absolutediff = navigation + fixedHeader;
        return $('body').hasClass('fix-fixed') ? 0 :absolutediff;
    }
})
.factory('$debounce', ['$rootScope', '$browser', '$q', '$exceptionHandler',
    function($rootScope,   $browser,   $q,   $exceptionHandler) {
        var deferreds = {},
            methods = {},
            uuid = 0;

        function debounce(fn, delay, invokeApply) {
            var deferred = $q.defer(),
                promise = deferred.promise,
                skipApply = (angular.isDefined(invokeApply) && !invokeApply),
                timeoutId, cleanup,
                methodId, bouncing = false;

            // check we dont have this method already registered
            angular.forEach(methods, function(value, key) {
                if(angular.equals(methods[key].fn, fn)) {
                    bouncing = true;
                    methodId = key;
                }
            });

            // not bouncing, then register new instance
            if(!bouncing) {
                methodId = uuid++;
                methods[methodId] = {fn: fn};
            } else {
                // clear the old timeout
                deferreds[methods[methodId].timeoutId].reject('bounced');
                $browser.defer.cancel(methods[methodId].timeoutId);
            }

            var debounced = function() {
                // actually executing? clean method bank
                delete methods[methodId];

                try {
                    deferred.resolve(fn());
                } catch(e) {
                    deferred.reject(e);
                    $exceptionHandler(e);
                }

                if (!skipApply) $rootScope.$apply();
            };

            timeoutId = $browser.defer(debounced, delay);

            // track id with method
            methods[methodId].timeoutId = timeoutId;

            cleanup = function(reason) {
                delete deferreds[promise.$$timeoutId];
            };

            promise.$$timeoutId = timeoutId;
            deferreds[timeoutId] = deferred;
            promise.then(cleanup, cleanup);

            return promise;
        }


        // similar to angular's $timeout cancel
        debounce.cancel = function(promise) {
            if (promise && promise.$$timeoutId in deferreds) {
                deferreds[promise.$$timeoutId].reject('canceled');
                return $browser.defer.cancel(promise.$$timeoutId);
            }
            return false;
        };

        return debounce;
}])
.directive('fixedTopAutoHeight', ['$interval', function($interval) {
    return {
        restrict: 'C',
        link: function(scope, iElement) {
            $interval(function() {
                scope.$fixedTopHeight = iElement.outerHeight();
            }, 50);
        }
    }
}])
.directive('mainMessages', ['$timeout', '$interval', '$filter', function($timeout, $interval, $filter) {
    return {
        restrict: 'C',
        scope: true,
        link: function(scope, element) {

            scope.messages = [];
            scope._removeMessage = function(index) {
                var data = scope.messages[index];
                scope.messages.splice(index, 1);
                scope.$parent.$broadcast('mainMessages:removed', data);
            };
            scope._flush = function(index) {
                _messages.splice(index, 1);
            };

            scope.height = 0;
            scope.refreshHeight = function() {
                var mainHeight = 0;
                $('.main-message-permanent, .main-message-current').each(function() {
                    var current = $(this),
                        height = current.height() + parseFloat(current.css('margin-top'), 10) + parseFloat(current.css('margin-bottom'), 10);
                    if(mainHeight < height) {
                        mainHeight = height;
                    }
                });
                scope.height = mainHeight || 0;
            };

            //Sync height
            $(window).on('resize', function() {
                scope.refreshHeight();
                scope.$apply();
            });
            scope.$on('ling:anim:show:after', function() {
                scope.refreshHeight();
            });
            scope.$on('ling:cmp:loader:after', function() {
                scope.refreshHeight();
            });

            scope.permanentCurrent = null;
            var refreshPermanentQueue = function(messages) {
                var counter = 0;
                scope.permanentCounter = {};
                angular.forEach(messages, function(message, i) {
                    counter++;
                    scope.permanentCurrent = i;
                    scope.permanentCounter[i] = counter;
                });
                $timeout(scope.refreshHeight);
            };

            scope.$watch('messages', refreshPermanentQueue, true);

                /**
                 * data:
                 *  type
                 *  content
                 *  timeout
                 *  close
                 */
            var addMessage = function(data) {
                    if(!angular.isDefined(data.timeout)) {
                        data.timeout = 5;
                    }
                    if(!angular.isDefined(data.close)) {
                        data.close = true;
                    }
                    var messageId = $filter('filter')(_messages, function(message) {
                        return data.id == message.id;
                    });
                    //If id was not specified or the message was not found in the queue
                    if(!data.id || !messageId.length) {
                        scope.messages.push(data);
                        _messages.push(data);
                    }
                },
                //Cache for id checking
                _messages = [];

            scope.$parent.$on('mainMessages:add', function(e, data) {
                addMessage(data);
            });

            //Init flashbag
            element.children('.main-message-flashbag').each(function() {
                addMessage({
                    type: $(this).data('type'),
                    content: $(this).html(),
                    timeout: $(this).data('timeout'),
                    close:  $(this).data('close')
                });
            });

        }
    }
}])
.directive('mainMessage', ['$timeout', '$compile', '$templateCache', function($timeout, $compile, $templateCache) {
    return {
        restrict: 'C',
        controller: ['$scope', function($scope) {
            $scope.show = true;
        }],
        link: function(scope, element) {

            scope.removeMessage = function() {
                scope.show = false;

                $timeout(function() {
                    scope._removeMessage(scope.$index);
                }, 300);
            };

            if(!!scope.message.timeout) {
                $timeout(function() {
                    scope.removeMessage();
                }, scope.message.timeout * 1000);
            }

            var content = null
            if(typeof scope.message.content !== 'object') {
                content = scope.message.content;
            } else {
                content = $templateCache.get('main-message-' + (scope.message.type) + '.html');
            }
            content = $compile($('<div class="main-message-content"/>').html(content))(scope);
            element.append(content);

            scope.$parent.$parent.$on('mainMessages:remove', function(e, id) {
                if(id === scope.message.id) {
                    scope.removeMessage();
                }
            });
            scope.$parent.$parent.$on('mainMessages:flush', function(e, id) {
                if(id === scope.message.id) {
                    scope._flush(scope.$index);
                }
            });
        }
    }
}])

//Custom modal extending
.directive('modal', function() {
    return {
        restrict: 'C',
        scope: true,
        link: function(scope, iElement) {
            scope.$on('modal:hide', function(e) {
                e.stopPropagation();
                iElement.modal('hide');
            });
        }
    }
})
.directive('modalAsync', ['helper', function(helper) {
    return {
        restrict: 'C',
        link: function(scope, iElement) {
            iElement.on('hide.bs.modal', function() {
                if (scope.pause) {
                    scope.pause();
                }
            }).on('show.bs.modal', function(e) {
                if(!helper.isMobile() && scope.play) {
                    scope.play();
                }
                //From link
                if($(e.relatedTarget).attr('href')) {
                    if($(e.relatedTarget).data('cache') === false) {
                        scope.$broadcast('remoteLoader:load', {
                            url: $(e.relatedTarget).attr('href')
                        });
                    } else {
                        scope.$broadcast('remoteLoader:load:cache', {
                            url: $(e.relatedTarget).attr('href')
                        });
                    }
                } else {
                //Manual content
                    scope.$broadcast('remoteLoader:active');
                }
            });
        }
    }
}])
.filter('nl2br', ['$sce', function ($sce) {
    return function (text) {
        return text ? $sce.trustAsHtml(text.replace(/\n/g, '<br/>')) : '';
    };
}])
;
